import { createFileRoute } from '@tanstack/react-router';

import { ResourceLibraryGrid } from '@/features/engagement-resources/components/ResourceLibraryGrid';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/engagement/resources/')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: ClinicalEngagementResourcesScreen,
  staticData: { crumb: 'Engagement' },
});

function ClinicalEngagementResourcesScreen() {
  return <ResourceLibraryGrid surface="clinical" />;
}
